export enum GraphqlServiceName {
    SWIPPY_SERVER = "SWIPPY_SERVER",
    NOTIFICATION_SERVER = "NOTIFICATION_SERVER"
}